import type { RenderComponentProps } from "replo-runtime/shared/types";

import React from "react";

import { ReploComponent } from "../../ReploComponent";

export const BundleHeader: React.FC<RenderComponentProps> = ({
  componentAttributes,
  component,
  context,
}) => {
  return (
    <div
      {...componentAttributes}
      style={{
        padding: "24px",
        borderBottom: "1px solid #eee",
        ...componentAttributes?.style,
      }}
    >
      {component.children?.map((child) => (
        <ReploComponent key={child.id} context={context} component={child} />
      ))}
    </div>
  );
};
